export default "__VITE_ASSET__$Vwa_4oO__"